<script>
import { required } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
export default {
    name: "MapModal",
    props: {
        modalTitle: String
    },
    
    validations: {
        form: {
            name: {required},
        }
    },  
    data(){
        return {
            form: {
                id: 0,
                name: "",
                description: null,
                parentDeliveryUnitServiceMapId: 0
            },
            submitted: false
        }
    },
    methods: {
        updateData(data){
            this.form = cloneDeep(data);
            this.form.parentDeliveryUnitServiceMapId = data.parentDeliveryUnitServiceMapId || 0;
            this.submitted = false;
        },
        resetForm(){
            this.form = {
                id: 0,
                name: "",
                description: null,
                parentDeliveryUnitServiceMapId: 0
            }
            this.submitted = false;
            this.$v.$reset();
        },
        onCreate(){
            this.submitted = true;
            this.$v.form.$touch();
            if(this.$v.form.$invalid) return;
            this.$emit('submit', this.form);
        }
    }
};
</script>
<template>
  <b-modal
        id="map-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation"
            ref="fcForm"
        >
            <div class="mb-3">
                <label for="name">Location Name</label>
                <input 
                    autocomplete="off"
                    id="name"
                    type="text" 
                    class="form-control"
                    v-model="form.name"
                    :class="{'is-invalid': submitted && $v.form.name.$error}"
                >
                <div class="invalid-feedback" v-if="submitted && $v.form.name.$error">
                    <span v-if="!$v.form.name.required">Service Name is required</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="description">Description</label>
                <textarea 
                    autocomplete="off"
                    id="description"
                    class="form-control"
                    v-model="form.description"
                ></textarea>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary"><i class="bx bx-save"></i>{{ form.id != 0 ? "Update" : "Save" }}</button>
                <button type="button" class="btn btn-link" @click="$bvModal.hide('map-modal')">Close</button>
            </div>
        </form>
    </b-modal>
</template>